import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { OfficialActContentDescriptor } from './model/officialact.content';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class OfficialActContentService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'OfficialActContentManagement',
      authService,
      config.OAMSConfig
    );
  }

  async GetList(v: View): Promise<List<OfficialActContentDescriptor>> {
    return await this.getOfficialActContents(v);
  }

  public getOfficialActContents(view?: View): Promise<List<OfficialActContentDescriptor>> {
    return super.get<List<OfficialActContentDescriptor>>(undefined, view);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/officialact/officialact.content.service.ts